import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/api/models';

@Pipe({
  name: 'findUsersByIds'
})
export class FindUsersByIdsPipe implements PipeTransform {

  transform(userIds: Array<number>, users: Array<User>): Array<User> | undefined {
    if (userIds && users) {
      return userIds.map(id => users.find(user => user.userId === id) );
    }
    return null;
  }

}
